import {
  ConsultaSeguimentoPergunta06Model,
  ConsultaSeguimentoPergunta06PegarEnum,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-06/model-consultaSeguimentoPergunta06'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { HISTORICO_MCHAT_CALCULATION_STATUS } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta06Model {
  header: MchatRfAplicacaoQueryModel
  perguntas: MchatRfAplicacaoQueryModel[]
  apontaPara: MchatRfAplicacaoQueryModel | undefined
  model: ConsultaSeguimentoPergunta06Model
}

export const convertAplicacaoPergunta06 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta06Model | null => {
  const header = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_06_01)
  const perguntas = aplicacoes.filter((aplicacao) => PERGUNTA_06_PERGUNTAS.includes(aplicacao.pergunta))
  const apontaPara = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_06_06)

  if (header === undefined) return null

  return {
    header,
    perguntas,
    apontaPara,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_06_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_06_PEGAR: convertAplicacoesToPegar(perguntas),
      PERGUNTA_06_APONTAR_PARA: booleanToSimNaoEnum(apontaPara?.stPassou),
    },
  }
}

const convertAplicacoesToPegar = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta06PegarEnum, ReturnType<typeof booleanToSimNaoEnum>> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta06PegarEnum, ReturnType<typeof booleanToSimNaoEnum>>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_PEGAR }
  )

const PERGUNTA_06_PERGUNTAS = [
  MChatPerguntaEnum.PERGUNTA_06_02,
  MChatPerguntaEnum.PERGUNTA_06_03,
  MChatPerguntaEnum.PERGUNTA_06_04,
  MChatPerguntaEnum.PERGUNTA_06_05,
]

const EMPTY_PEGAR: Record<ConsultaSeguimentoPergunta06PegarEnum, undefined> = {
  [ConsultaSeguimentoPergunta06PegarEnum.TENTA_ALCANCAR]: undefined,
  [ConsultaSeguimentoPergunta06PegarEnum.LEVA_ATE]: undefined,
  [ConsultaSeguimentoPergunta06PegarEnum.TENTA_PEGAR]: undefined,
  [ConsultaSeguimentoPergunta06PegarEnum.PEDE]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta06PegarEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_06_02]: ConsultaSeguimentoPergunta06PegarEnum.TENTA_ALCANCAR,
  [MChatPerguntaEnum.PERGUNTA_06_03]: ConsultaSeguimentoPergunta06PegarEnum.LEVA_ATE,
  [MChatPerguntaEnum.PERGUNTA_06_04]: ConsultaSeguimentoPergunta06PegarEnum.TENTA_PEGAR,
  [MChatPerguntaEnum.PERGUNTA_06_05]: ConsultaSeguimentoPergunta06PegarEnum.PEDE,
}
